import { useSelector } from "react-redux";
import useUserTier from "./useUserTier";

// service can be ai, alert, bot, insight, tradeSimulator, subscription

const serviceConvertor = {
  ai: "myais",
  alert: "alert",
  bot: "mybot",
  insight: "insai",
  tradeSimulator: "trsim",
};

function usePricing(service = "") {
  const {
    pricingPlan: { pricingPlan },
  } = useSelector((state) => state);
  const yearlyDiscount = pricingPlan["yearly_discount"];

  const serviceKey = serviceConvertor?.[service];

  const { serviceType } = useUserTier(serviceKey);
  const { serviceType: basicSubscription } = useUserTier("subscription");
  const { serviceType: proSubscription } = useUserTier("subscription_aiSignal");

  const serviceCost = pricingPlan[serviceType];
  // cost is per month
  const basicPlanMonthlyCost = pricingPlan[basicSubscription];
  const proPlanMonthlyCost = pricingPlan[proSubscription];
  const basicPlanYearlyCost = (1 - yearlyDiscount / 100) * basicPlanMonthlyCost;
  const proPlanYearlyCost = (1 - yearlyDiscount / 100) * proPlanMonthlyCost;

  const proYearlyRegularCost = proPlanMonthlyCost * 12;
  const proYearlyTotalCost = proPlanYearlyCost * 12;
  const proYearlyDiscount = proYearlyRegularCost - proYearlyTotalCost;

  const basicYearlyRegularCost = basicPlanMonthlyCost * 12;
  const basicYearlyTotalCost = basicPlanYearlyCost * 12;
  const basicYearlyDiscount = basicYearlyRegularCost - basicYearlyTotalCost;

  return {
    yearlyDiscount,
    basicPlanYearlyCost,
    proPlanMonthlyCost,
    proPlanYearlyCost,
    basicPlanMonthlyCost,
    serviceCost,
    proYearlyTotalCost,
    proYearlyDiscount,
    proYearlyRegularCost,
    basicYearlyRegularCost,
    basicYearlyTotalCost,
    basicYearlyDiscount,
  };
}

export default usePricing;
